export default __webpack_public_path__ + "static/Entenda0075-159c533737e5b0557ea6369f25dd427f.jpg";